import axios from 'axios';

/** The HTTP status of a failed request, or `undefined` if the error is not a response from the server. */
export function httpStatus(error: unknown): number | undefined {
  return axios.isAxiosError(error) ? error.response?.status : undefined;
}

/** True for responses the app treats as "there is nothing": 404 (and 400, which the backend uses alike). */
export function isNotFound(error: unknown): boolean {
  const status = httpStatus(error);
  return status === 404 || status === 400;
}

/** The `message` of the backend's error response, if there is one. */
export function errorMessage(error: unknown): string | undefined {
  if (!axios.isAxiosError(error)) {
    return undefined;
  }
  const data = error.response?.data as {message?: unknown} | undefined;
  return typeof data?.message === 'string' ? data.message : undefined;
}
